import { Component, input, ViewEncapsulation } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-dashboard-chart-empty-state",
  standalone: true,
  imports: [MatIconModule, TranslateModule],
  templateUrl: "./dashboard-chart-empty-state.component.html",
  styleUrls: ["./dashboard-chart-empty-state.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardChartEmptyStateComponent {
  readonly messageKey = input.required<string>();
  readonly minHeight = input("12.75rem");
}
